import { Component, OnInit, Input, Output, EventEmitter, ViewChildren, AfterViewInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-addbranchpopup',
  templateUrl: './addbranchpopup.component.html',
  styleUrls: ['./addbranchpopup.component.css']
})
export class AddbranchpopupComponent implements OnInit ,AfterViewInit {

  @ViewChildren('input')firstipcontrol;
  
  @ViewChild('documentbar', { static: false }) documentbar;
  
  formname: string = "Branch";
  trxtype: string = "BRANCH";
  
//Display
formmode:string="Add";

 //Mode Values
 isaddmode:boolean=false;
 iseditmode:boolean=false;
 isdeletemode:boolean=false;
 isviewmode:boolean=false;

 isloading: boolean = false;
   isprivilage: boolean = false;
   showProgress: boolean = false;   


 //Save Validation
 submitted:boolean;
 successfully:boolean;
 saveloading: boolean;

 //Edit Get Values
 companycheckColl:any=[];
 branchColl:any=[];
 branchBO:any={};
 branchid:number=0
 
 branchform=new FormGroup({
  branchid:new FormControl(0),        
  branchcode:new FormControl('',Validators.required),         
  branchname:new FormControl('',Validators.required),          
 });

 @Output() emitData = new EventEmitter();

  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private activeModal: NgbActiveModal,) {

    this.fnServiceChanges();
  }

  
fnServiceChanges() {
  this.loginService.serviceAuthChange.subscribe((value) => {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.fnUserFailedForm();
    }

  });
}



ngOnInit() {
  try {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.loginService.fnGetUserRoleList();
    }

  } catch (ex) {
    this.fnShowErrorMsg(ex);
  }
}

fnOnInitForm() {
    try{
        this.isaddmode=true;
        this.branchform.reset();
        this.fnInitializeFormGroup(); 

      
    }catch(ex){
      this.fnShowErrorMsg(ex);
    }
}
fnCheckUserPririvilage() {
  var _check: boolean = false;
  if (this.branchid > 0) {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
  } else {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
  }

  return _check;
}

fnUserFailedForm() {
  this.isprivilage = true;
}  
ngAfterViewInit()
{
  //this.firstipcontrol.first.nativeElement.focus();
}
fnInitializeFormGroup(){
    this.branchform.setValue({
      branchid:0,    
      branchcode:'',
      branchname:'',              
    })
}








//Save Btn Click
fnSaveBtnClick(){
    try{
      if (this.saveloading) {
        return;        
    }                           
      this.submitted=true;
      this.successfully=false;
      //Validate
      if(this.branchform.valid){
          //Check
          this.saveloading = true;
 
          var data = {
                'branchid': this.branchid,       
                'branchcode':this.branchform.get('branchcode').value,            
                'branchname':this.branchform.get('branchname').value,            
            'companyid': this.loginService.fnGetCompanyId(),
                'inactive':false,
                'createdby': this.loginService.fnGetModUserId(),  
               'modifiedby':this.loginService.fnGetModUserId(),                                                              
          }

        
          this.appService.fnCheckBranch(data).subscribe(
            (res)=>{
              if(res.json().status===200){  
                var _checkresult=res.json().result[0].checkfield;
              
                if(_checkresult==="done"){
                     
                        //Insert 
                        this.fnInsertBranch(data);
                      }
              
                else{        
                      if(_checkresult==="code"){
                        this.saveloading = false;

                        this.branchform.controls['branchcode'].setErrors({'notfound': true});
                      }
                }
              }
              else {
                this.saveloading = false;

                this.loginService.fnAPIError(res.json())
              }
          },
          (err)=>{
            this.saveloading = false;

              this.toastr.error('Error', err);           
          });
       }
    }catch(ex){
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
}

//Insert
fnInsertBranch(data){    
  
    this.appService.fnInsertBranch(data).subscribe(
      (res)=>{
        this.saveloading = false;

        if(res.json().status===200){  
          if(res.json().result!=""){
            this.toastr.success('', "The new Branch has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, data.branchname);
            var result = res.json().result;
            
            var branchid = 0;
            if (result.length > 0) {
              branchid = result[0].branchid
            }
            this.emitData.emit(branchid);
            this.activeModal.close(true);
  

          }  
          else {
            this.loginService.fnAPIError(res.json())
          }
        }
        (err) => {
          this.saveloading = false;        
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }

fnInsertActivityLog(action,refno,desc){
  try{
    var data={
      logtype:action,
      logat:this.formname,
      refnum:refno,
      logdescr:desc,companyid: this.loginService.fnGetCompanyId(),         
      logby:this.loginService.fnGetModUserId(),
    }
  

    this.appService.fnInsertActivity(data).subscribe(
      (res)=>{
      },
      (err)=>{
     
      });

  }catch{

  }
}
public decline() {
  this.activeModal.close(false);
}


private fnShowErrorMsg(ex) {
  this.toastr.warning('Internal Error', ex);
}


}




